const routes = {
  ability: '/habilidad/:rut',
  callback: '/callback',
  contractualBehavior: '/comportamiento/:rut',
  documents: '/documentos/:rut',
  enrollmentCertificateBySeller: '/certificado/:rut',
  enrollmentCertificateByTender: '/certificado/inscripcion',
  generalInformation: '/informacion-general/:rut',
  historicalContract: '/contrato/historico/:rut',
  historicalSanctionsList: '/sancion/historico/:rut',
  registerSanction: '/sancion/:rut',
  sanctionDetails: '/sancion/:rut/:id',
  sellerCard: '/:rut',
  suitability: '/idoneidad/:rut',
  temporaryUnions: '/uniones-temporales/:rut',
  workRegister: '/registro-obras/:rut',
  notFound: '/404'
}

export default routes
